module.exports = __webpack_public_path__ + "img/Intersection 29@2x.d963f43d.png";